/*
 * Payment details filters in the URL: view=awaiting (the review queue is the default) and
 * since=YYYY-MM. Pure parse/serialise; defaults are left out.
 */
import { since_month_error } from './adapters';

export const VIEW_PENDING = 'pending';
export const VIEW_AWAITING = 'awaiting';
export const PAYMENT_DETAILS_URL_KEYS = ['view', 'since'];

export const parse_payment_details_filters = (search) => {
  const qs = new URLSearchParams(typeof search === 'string' ? search : '');
  const since = (qs.get('since') || '').trim();
  return {
    view: qs.get('view') === VIEW_AWAITING ? VIEW_AWAITING : VIEW_PENDING,
    since: since && !since_month_error(since) ? since : ''
  };
};

export const payment_details_query = ({ view, since }) => ({
  view: view === VIEW_AWAITING ? VIEW_AWAITING : '',
  since: since || ''
});
